'use strict';

import { view } from '@/functions';

const prefix = '/withdrawals';
export default [
	{
		path: prefix,
		name: 'withdrawals',
		meta: {
			title: 'Withdrawals',
			scopes: ['read_withdrawals', 'write_withdrawals', 'block_withdrawals']
		},
		component: () => view('withdrawals/index')
	},
	{
		path: `${prefix}/summary/info`,
		name: 'withdrawals-summary-info',
		meta: {
			title: 'Withdrawals',
			scopes: ['read_withdrawals', 'block_withdrawals']
		},
		props: (route) => ({
			summaryId: route.query.id || null,
			withdrawalId: route.query.withdrawal_id || null,
		}),
		component: () => view('withdrawals/summary-info')
	},
]; 